import { SetState, GetState } from 'zustand';

import { ILoginResponse } from '../types';
import { newUser } from '../constants/objects';
import { getFromSessionStorage } from '../services/storage.service';

export interface IUserSlice {
    user: ILoginResponse,
    fingerPrint: string,
    setUser: (user: ILoginResponse) => void,
    setFingerPrint: (fp: string) => void,
  getFingerPrint: () => string,
    currUser: () => ILoginResponse,
    hydrateCustomerId: () => Promise<any>
  resetUserSliceId: (id: string) => void;
  resetEntireUserSlice: () => void;
}

const createUserSlice = (set: SetState<IUserSlice>, get: GetState<IUserSlice>) => ({
  user: ({
    ...newUser,
  }),
  fingerPrint: '',
  currUser: () => get().user,
  setUser: (user: ILoginResponse) => {
    set({ user });
  },
  setFingerPrint: (fp: string) => {
    set({ fingerPrint: fp });
  },
  getFingerPrint: () => {
    const fp = get().fingerPrint;
    return fp;
  },
  hydrateCustomerId: () => new Promise((res) => {
    const id = getFromSessionStorage('customerId');
    const currUser = get().user;
    set({ user: ({ ...currUser, customerId: id }) });
    res(id ?? '');
  }),
  resetUserSliceId: (id: string) => {
    const currUser = get().user;
    set({ user: { ...currUser, customerId: id } });
  },
  resetEntireUserSlice: () => {
    set({ user: { ...newUser }, fingerPrint: '' });
  },
});

export default createUserSlice;
